module.exports = __webpack_public_path__ + "assets/img/img267.65c00e3a.png";